import React, { Component } from "react";
import InputForm from "./InputForm";
import axios from "axios";
import { Button, Col, Tooltip, message } from 'antd';


class PessoaFrame extends Component {
    state = {
        lista: [],
        codigo: {
            key: '0',
            label: '',
        },
        buscando: false,
        abrirLista: false,
        carregandoTodos: false,
    }

    componentDidUpdate(propsAnterior, stateAnterior) {
        if (this.state.codigo.key !== this.props.value.key) {
            // Mantém a lista já carregada. Atualiza somente a pessoa selecionada,
            // igual ao comportamento do ProdutoFrame.
            this.setState({
                codigo: {
                    key: this.props.value.key,
                    label: this.props.value.label ? this.props.value.label : '',
                },
            })
        }
    }

    componentDidMount() {
        // this.getListaRegistros();
    }

    abrirDropdownPessoas = () => {
        // `open`/`dropdownVisible` são a forma principal.
        // O fallback abaixo garante a abertura também em versões antigas
        // do InputForm/Ant Design.
        setTimeout(() => {
            if (!this.pessoaFrameContainer) return;

            const select = this.pessoaFrameContainer.querySelector('.ant-select');
            const input = this.pessoaFrameContainer.querySelector('.ant-select-search__field');
            const selection = this.pessoaFrameContainer.querySelector('.ant-select-selection');

            if (input && input.focus) {
                input.focus();
            }

            if (select && select.classList.contains('ant-select-open')) {
                return;
            }

            if (selection) {
                selection.dispatchEvent(new MouseEvent('mousedown', {
                    view: window,
                    bubbles: true,
                    cancelable: true,
                }));
            }
        }, 80);
    };

    fecharMensagemCarregando = () => {
        if (this.hideMensagemCarregando) {
            this.hideMensagemCarregando();
            this.hideMensagemCarregando = null;
        }
    };

    onCarregarTodos = () => {
        this.fecharMensagemCarregando();
        this.hideMensagemCarregando = message.loading('Carregando...', 0);
        this.getListaRegistros('', true);
    };

    getListaRegistros = (value, abrirAposCarregar = false) => {
        // Enquanto digita, mantém o dropdown e o foco abertos.
        // Não esvazia as opções antes de receber o próximo resultado.
        const buscaAtual = (this.sequenciaBusca || 0) + 1;
        this.sequenciaBusca = buscaAtual;
        this.setState({
            abrirLista: true,
            buscando: true,
            carregandoTodos: abrirAposCarregar,
        });

        clearTimeout(this.buscaRegistrosId);
        this.buscaRegistrosId = setTimeout(() => {
            axios.get('/pessoas/lista', {
                params: {
                    nome: value,
                    situacao: 'A',
                    ehCodigo: ((value) && (parseInt(value)) && (value.length <= 6)) ? 1 : 0,
                    tipo: this.props.tipo
                }
            }).then(response => {
                // Descarta respostas de consultas antigas que chegaram atrasadas.
                if (buscaAtual !== this.sequenciaBusca) return;
                const { data } = response;
                const temPessoas = Array.isArray(data) && data.length > 0;

                const lista = data.map(regList => {
                    return {
                        key: regList.pes_idf,
                        label: regList.pes_nome + ' [' + regList.pes_codigo + '] ' + (regList.pes_cpf_cnpj !== '' ? ' [' + regList.pes_cpf_cnpj + '] ' : ''),
                        cliente: regList.pes_cliente,
                        fornec: regList.pes_fornecedor,
                        pes_ind_ie: regList.pes_ind_ie,
                        cuf_codigo: regList.cuf_codigo,
                        cuf_sigla: regList.cuf_sigla,
                    }
                });

                if ((value) && (parseInt(value)) && (value.length <= 6) && (lista.length = 1)) {
                    // console.log('getListaRegistros: ', lista);

                    const value = {
                        key: String(lista[0].key),
                        label: lista[0].label,
                        cliente: lista[0].cliente,
                        fornec: lista[0].fornec,
                        pes_ind_ie: lista[0].pes_ind_ie,
                        cuf_codigo: lista[0].cuf_codigo,
                        cuf_sigla: lista[0].cuf_sigla,
                    };
                    this.setState({
                        [this.props.id]: value,
                        codigo: value,
                        cliente: lista[0].cliente,
                        fornec: lista[0].fornec,
                        pes_ind_ie: lista[0].pes_ind_ie,
                        cuf_codigo: lista[0].cuf_codigo,
                        cuf_sigla: lista[0].cuf_sigla,
                    });
                    const state = {};
                    state[this.props.id] = value;
                    this.props.onChange(state);

                } else {
                    if ((this.props.descricaoPrimeiroItem) && (this.props.descricaoPrimeiroItem !== '')) {
                        lista.unshift({ key: '0', label: this.props.descricaoPrimeiroItem });
                    }
                }

                this.setState({
                    lista,
                    buscando: false,
                    carregandoTodos: false,
                    abrirLista: true,
                }, () => {
                    if (abrirAposCarregar) {
                        this.fecharMensagemCarregando();
                    }

                    if (abrirAposCarregar && temPessoas) {
                        this.abrirDropdownPessoas();
                    }
                })
            }).catch(error => {
                if (buscaAtual !== this.sequenciaBusca) return;
                console.error(error.response);
                this.fecharMensagemCarregando();
                this.setState({
                    lista: [],
                    buscando: false,
                    carregandoTodos: false,
                    abrirLista: true,
                })
            })
        }, 350);
    };

    onChange = event => {
        clearTimeout(this.buscaRegistrosId);
        this.sequenciaBusca = (this.sequenciaBusca || 0) + 1;
        // console.log('PessoaFrame onChange : ', event);
        const value = event.target.value;
        const id = event.target.id;
        const state = {};
        const iInd = this.state.lista.findIndex(registro => String(registro.key) === String(value.key));
        if (iInd < 0) return;
        state[id] = {
            key: value.key,
            label: value.label,
            codigo: value,
            cliente: this.state.lista[iInd].cliente,
            fornec: this.state.lista[iInd].fornec,
            pes_ind_ie: this.state.lista[iInd].pes_ind_ie,
            cuf_codigo: this.state.lista[iInd].cuf_codigo,
            cuf_sigla: this.state.lista[iInd].cuf_sigla,
        };

        // Mantém a lista completa carregada e altera apenas a pessoa selecionada.
        // Ao selecionar, fecha imediatamente o dropdown.
        this.setState({
            codigo: {
                key: value.key,
                label: value.label,
            },
            abrirLista: false,
        }, () => {
            if (this.pessoaFrameContainer) {
                const input = this.pessoaFrameContainer.querySelector('.ant-select-search__field');
                if (input && input.blur) {
                    input.blur();
                }

                const selection = this.pessoaFrameContainer.querySelector('.ant-select-selection');
                if (selection && selection.blur) {
                    selection.blur();
                }
            }
        });

        this.props.onChange(state);
    };

    componentWillUnmount() {
        this.sequenciaBusca = (this.sequenciaBusca || 0) + 1;
        clearTimeout(this.buscaRegistrosId);
        this.fecharMensagemCarregando();
    }

    onDropdownVisibleChange = (visivel) => {
        this.setState({ abrirLista: Boolean(visivel) });
    };



    render() {
        const { label, id, width, disabled } = this.props;
        const { lista, codigo, buscando, abrirLista, carregandoTodos } = this.state;

        // console.log('PessoaFrame - this.props: ', this.props);
        // console.log('PessoaFrame - this.state: ', this.state);

        return (
            <span style={{}} ref={ref => { this.pessoaFrameContainer = ref; }}>
                <div>{label}</div>
                <InputForm
                    type="select"
                    id={id}
                    ref={id}
                    value={codigo}
                    onChange={this.onChange}
                    data={lista}
                    validator={value => Boolean(value)}
                    onSearch={this.getListaRegistros}
                    fetching={buscando}
                    open={abrirLista}
                    dropdownVisible={abrirLista}
                    onDropdownVisibleChange={this.onDropdownVisibleChange}
                    showArrow={false}
                    filterOption={false}
                    notFoundContent={buscando ? 'Carregando...' : null}
                    defaultActiveFirstOption={false}
                    showSearch
                    style={{ width: width }}
                    disabled={disabled ? true : false}
                    placeholder="Digite o Nome"
                />
                <div style={{ float: "right", margin: 0, padding: 0, marginTop: -63 }}>
                    <Tooltip title={carregandoTodos ? "Carregando..." : "Carregar Todos"}>
                        <Button
                            type="ghost"
                            icon="reload"
                            onClick={this.onCarregarTodos}
                            loading={carregandoTodos}
                            style={{ color: 'rgba(0,0,0,0.4)', fontSize: 20, marginTop: 4, marginLeft: -39, borderWidth: 0 }}
                        />
                    </Tooltip>
                </div>
            </span>
        );
    }
}

export default PessoaFrame;



// WEBPACK FOOTER //
// ./src/components/PessoaFrame.js